import { Outlet, useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import IdleTimer from './IdleTimer';
import { useAuth } from 'react-oidc-context';
import { InactiveTime, ROLE } from '../interface/interface';
import { PageScrollContext } from '../context/pageScrollContext';
import { useContext, useRef } from 'react';
import FloatingCart from './FloatingCart';
import { UserContext } from '../context/userContext';

const Layout = () => {
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);
  const auth = useAuth();
  const { loadingEnable, isMobile } = useContext(UserContext);
  const handleIdle = () => {
    localStorage.removeItem('impersonateUser');
    auth?.signoutRedirect();
  };
  const isOrdersTable = location.pathname.endsWith('/orders');
  const isProductTable = location.pathname.endsWith('/products');
  const home = location.pathname.endsWith('/home');

  const handleScroll = (e: React.UIEvent<HTMLElement>) => {
    const { scrollTop } = e.currentTarget;
    if (isProductTable) localStorage.setItem('product', String(scrollTop));
  };

  function maxWithScreen() {
    if (
      (auth?.user?.profile?.groups as string[] | undefined)?.includes(
        ROLE.Doctors,
      ) &&
      home
    )
      return true;

    return isOrdersTable || isProductTable;
  }

  return (
    <>
      {/* 
    60000 ms - 1 minutes
    600000 ms - 10 minutes
    900000 ms - 15 minutes
    43200000 ms - 12 hours
    */}

      <IdleTimer
        timeout={
          process.env.VITE_ERX === 'ENABLE'
            ? InactiveTime.FIFTEEN_MIN
            : InactiveTime.ALL_DAY
        }
        onIdle={handleIdle}
      />
      <NavBar />
      <PageScrollContext.Provider value={{ mainRef }}>
        <main
          ref={mainRef}
          className="bg-body-pattern bg-no-repeat bg-100 overflow-y-auto bg-white xs:pb-20 lg:pb-0"
          onScroll={handleScroll}
        >
          <div
            className={`w-full px-6 md:px-16 lg:px-0 mx-auto mt-6 lg:mt-14 mb-12 md:mb-72 ${maxWithScreen() ? 'lg:w-[95%]' : 'lg:w-11/12 2xl:w-10/12'}`}
          >
            <Outlet />
            {(auth.user?.profile?.groups as Array<string>)?.includes(
              ROLE.Patients,
            ) &&
              !loadingEnable &&
              !isMobile && <FloatingCart />}
          </div>
        </main>
      </PageScrollContext.Provider>
    </>
  );
};

export default Layout;
